import React, {useCallback, useState} from 'react';

import {
    Typography,
    AppBar,
    Toolbar,
    IconButton,
    Container,
    Card,
    CardContent,
    Button,
    TableRow,
    TableCell,
    Table, TableBody, Divider,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {useNavigate, useParams} from 'react-router-dom';
import {useEffectAsync} from '../reactHelper';
import {useTranslation} from '../common/components/LocalizationProvider';
import MapView from '../map/core/MapView';
import MapCamera from '../map/MapCamera';
import MapPositions from '../map/MapPositions';
import MapGeofence from '../map/MapGeofence';
import StatusCard from '../common/components/StatusCard';
import {formatNotificationTitle} from '../common/util/formatter';
import useDeviceAttributes from "../common/attributes/useDeviceAttributes";
import {useSelector} from "react-redux";
import moment from "moment";
import PositionValue from "../common/components/PositionValue";
import SendIcon from '@mui/icons-material/Send';
import InfoIcon from '@mui/icons-material/Info';
import useMediaQuery from "@mui/material/useMediaQuery";
import {useTheme} from "@mui/material/styles";

const useStyles = makeStyles(() => ({
    root: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    toolbar: {
        zIndex: 1,
    },
    mapContainer: {
        flexGrow: 1,
    },
}));

const EventPage = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const t = useTranslation();

    const theme = useTheme();
    const phone = useMediaQuery(theme.breakpoints.down('md'));

    const {id} = useParams();

    const [event, setEvent] = useState();
    const [position, setPosition] = useState();
    const [showCard, setShowCard] = useState(false);

    const deviceAttributes = useDeviceAttributes(t);
    const devices = useSelector((state) => state.devices.items);

    const onMarkerClick = useCallback((positionId) => {
        setShowCard(!!positionId);
    }, [setShowCard]);

    useEffectAsync(async () => {
        if (id) {
            const response = await fetch(`/api/events/${id}`);
            if (response.ok) {
                setEvent(await response.json());
            } else {
                throw Error(await response.text());
            }
        }
    }, [id]);

    useEffectAsync(async () => {
        if (event && event.id) {
            const response = await fetch(`/api/positions?id=${event.id}`);
            if (response.ok) {
                const positions = await response.json();
                if (positions.length > 0) {
                    setPosition(positions[0]);
                }
            } else {
                throw Error(await response.text());
            }
        }
    }, [event]);

    const handlePosition = () => {
        navigate(`/position/${event.id}`);
    };

    const getDeviceParams = (idto) => {
        devices.filter(device => device.key === idto).map(filteredDevice => {
                return (
                    <h3>{filteredDevice}</h3>
                )
            }
        )
    };

    const formatDate = (dateToFormat) => {
        var dateFormatted = moment(dateToFormat).format('YYYY/MM/DD hh:mm:ss A')
        return dateFormatted.toString()
    };


    return (
        <div className={classes.root}>
            <AppBar position="sticky" color="inherit">
                <Toolbar>
                    <IconButton color="inherit" edge="start" sx={{mr: 2}} onClick={() => navigate('/')}>
                        <ArrowBackIcon/>
                    </IconButton>
                    <Typography variant="h6">
                        {event && formatNotificationTitle(t, event)}
                    </Typography>
                </Toolbar>
            </AppBar>
                <div>
                    <Container>

                        {event && position && (
                        <Card variant="outlined" style={{marginTop: "2vh", marginBottom: "2vh"}}>
                            <CardContent>
                                    {Object.entries(devices).filter(device => device[1].id === position.deviceId).map((filteredDevice, id) => (
                                        <div key={id}>
                                            <div style={phone ? {textAlign: "center", marginBottom: "2vh", fontSize: "1.2rem", fontWeight: "500"}
                                                :
                                                {display: "flex", justifyContent: "space-between", margin: "4vh 2vw 4vh 2vw", fontSize: "1.4rem", fontWeight: "500"}}>
                                                <div>{filteredDevice[1].name}</div>
                                                    <PositionValue
                                                        position={position}
                                                        property={position.hasOwnProperty('tempCalculated') ? position.hasOwnProperty('tempCalculated') : null}
                                                        attribute={position.attributes.hasOwnProperty('tempCalculated') ? "tempCalculated" : null}
                                                        showUnit={true}
                                                    />
                                                <div>{formatDate(event.eventTime)}</div>
                                            </div>
                                            <Divider variant="medium"/>
                                            <div>
                                            <Table>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell>name:</TableCell>
                                                        <TableCell>{filteredDevice[1].name}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>identifier:</TableCell>
                                                        <TableCell>{filteredDevice[1].attributes.identifier}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>uniqueId:</TableCell>
                                                        <TableCell>{filteredDevice[1].uniqueId}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>status:</TableCell>
                                                        <TableCell>{filteredDevice[1].status}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>tempCalculated:</TableCell>
                                                        <TableCell>
                                                            <PositionValue
                                                                position={position}
                                                                property={position.hasOwnProperty('tempCalculated') ? position.hasOwnProperty('tempCalculated') : null}
                                                                attribute={position.attributes.hasOwnProperty('tempCalculated') ? "tempCalculated" : null}
                                                                showUnit={true}
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>lowTemp:</TableCell>
                                                        <TableCell>
                                                            <PositionValue
                                                                position={filteredDevice[1]}
                                                                property={filteredDevice[1].hasOwnProperty('lowTemp') ? position.hasOwnProperty('lowTemp') : null}
                                                                attribute={filteredDevice[1].attributes.hasOwnProperty('lowTemp') ? "lowTemp" : null}
                                                                showUnit={true}
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>hiTemp:</TableCell>
                                                        <TableCell>
                                                            <PositionValue
                                                                position={filteredDevice[1]}
                                                                property={filteredDevice[1].hasOwnProperty('hiTemp') ? position.hasOwnProperty('hiTemp') : null}
                                                                attribute={filteredDevice[1].attributes.hasOwnProperty('hiTemp') ? "hiTemp" : null}
                                                                showUnit={true}
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>eventTime:</TableCell>
                                                        <TableCell>{formatDate(event.eventTime)}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell>lastUpdate:</TableCell>
                                                        <TableCell>{formatDate(filteredDevice[1].lastUpdate)}</TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                            </div>
                                        </div>
                                    ))}
                                <div style={{display: "flex", justifyContent: "center", margin: "4vh 2vw 0vh 2vw"}}>
                                    <Button variant="outlined" endIcon={<InfoIcon />} onClick={handlePosition}>{t('sharedShowDetails')}</Button>
                                </div>
                            </CardContent>
                        </Card>
                        )}
                    </Container>
                    {showCard && (
                        <div style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "80vh"
                        }}>
                            <StatusCard
                                deviceId={position.deviceId}
                                position={position}
                                onClose={() => setShowCard(false)}
                                disableActions
                            />
                        </div>
                    )}
                </div>
        </div>
    );
};

export default EventPage;
